export class LoginWithFacebookModalActions {
    login: () => void;
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/event.details/login.with.facebook.modal/login.with.facebook.modal.actions.ts